export default __webpack_public_path__ + "static/media/natalie_name.a2796453.png";